import { render, staticRenderFns } from "./OperaGoodsOrderDetail.vue?vue&type=template&id=123cd1b2&scoped=true&"
import script from "./OperaGoodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsOrderDetail.vue?vue&type=style&index=0&id=123cd1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123cd1b2",
  null
  
)

export default component.exports